<template>
  <basic-container>
    <div class="rail-record-page">
      <el-form :inline="true" size="small" class="rail-record-search">
        <el-form-item label="过车时间">
          <el-date-picker
            v-model="queryTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            clearable
          />
        </el-form-item>
        <el-form-item label="客户">
          <el-input
            v-model.trim="query.customerName"
            placeholder="请输入客户名称"
            clearable
            @keyup.enter.native="loadPreview"
          />
        </el-form-item>
        <el-form-item label="车号">
          <el-input
            v-model.trim="query.trainNo"
            placeholder="请输入车号"
            clearable
            @keyup.enter.native="loadPreview"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="loadPreview">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          <el-button type="primary" plain icon="el-icon-printer" :loading="exporting" @click="handleExportPdf">导出PDF</el-button>
        </el-form-item>
      </el-form>

      <div v-loading="loading" class="rail-record-content">
        <el-empty v-if="!groups.length" description="暂无轨道衡过衡记录" />

        <section
          v-for="(group, groupIndex) in groups"
          :key="group.groupKey || groupIndex"
          class="print-block"
        >
          <h2>轨道衡过衡记录</h2>
          <div class="print-meta">
            <span>客户：{{ group.customerName || '' }}</span>
            <span>车号：{{ group.trainNo || '' }}</span>
            <span>煤种：{{ group.coalType || '' }}</span>
            <span>重车时间：{{ group.heavyTime || '' }}</span>
          </div>

          <el-table
            :data="group.details || []"
            border
            size="small"
            class="print-table"
            show-summary
            :summary-method="summaryMethod(group)"
            :header-cell-style="{ background: '#f5f7fa', color: '#303133' }"
          >
            <el-table-column label="序号" prop="serialNo" width="70" align="center" />
            <el-table-column label="车节号" prop="carriageNo" min-width="120" />
            <el-table-column label="过重时间" prop="heavyTime" min-width="180" />
            <el-table-column label="过空时间" prop="emptyTime" min-width="180" />
            <el-table-column label="重车重量(吨)" prop="heavyWeight" min-width="130" align="right">
              <template slot-scope="{ row }">{{ formatWeight(row.heavyWeight) }}</template>
            </el-table-column>
            <el-table-column label="空车重量(吨)" prop="emptyWeight" min-width="130" align="right">
              <template slot-scope="{ row }">{{ formatWeight(row.emptyWeight) }}</template>
            </el-table-column>
            <el-table-column label="净重(吨)" prop="netWeight" min-width="120" align="right">
              <template slot-scope="{ row }">{{ formatWeight(row.netWeight) }}</template>
            </el-table-column>
          </el-table>

          <div class="sign-row">
            <span>日期：__________</span>
            <span>签名：________</span>
          </div>
        </section>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { exportPdf, getPrintPreview } from "./api";

export default {
  data() {
    return {
      loading: false,
      exporting: false,
      queryTime: [],
      query: {
        customerName: "",
        trainNo: ""
      },
      groups: []
    };
  },
  created() {
    this.queryTime = this.getTodayRange();
    this.loadPreview();
  },
  methods: {
    getTodayRange() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return [`${year}-${month}-${day} 00:00:00`, `${year}-${month}-${day} 23:59:59`];
    },
    buildParams() {
      const params = {};
      if (this.queryTime && this.queryTime.length === 2) {
        params.startTime = this.queryTime[0];
        params.endTime = this.queryTime[1];
      }
      if (this.query.customerName) {
        params.customerName = this.query.customerName;
      }
      if (this.query.trainNo) {
        params.trainNo = this.query.trainNo;
      }
      return params;
    },
    loadPreview() {
      const params = this.buildParams();
      if (!params) {
        return;
      }
      this.loading = true;
      getPrintPreview(params)
        .then(res => {
          this.groups = (res.data && res.data.data) || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetSearch() {
      this.queryTime = this.getTodayRange();
      this.query = {
        customerName: "",
        trainNo: ""
      };
      this.loadPreview();
    },
    handleExportPdf() {
      const params = this.buildParams();
      if (!params) {
        return;
      }
      this.exporting = true;
      exportPdf(params)
        .then(res => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `轨道衡过衡记录_${Date.now()}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.exporting = false;
        });
    },
    formatWeight(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }
      const numberValue = Number(value);
      return Number.isNaN(numberValue) ? value : numberValue.toFixed(2);
    },
    summaryMethod(group) {
      return ({ columns }) => {
        return columns.map((column, index) => {
          if (index === 0) {
            return "合计";
          }
          if (column.property === "heavyWeight") {
            return this.formatWeight(group.totalHeavyWeight);
          }
          if (column.property === "emptyWeight") {
            return this.formatWeight(group.totalEmptyWeight);
          }
          if (column.property === "netWeight") {
            return this.formatWeight(group.totalNetWeight);
          }
          return "";
        });
      };
    }
  }
};
</script>

<style scoped lang="scss">
.rail-record-page {
  background: #fff;
}

.rail-record-search {
  padding: 8px 0 14px;
  border-bottom: 1px solid #ebeef5;
}

.rail-record-content {
  min-height: 320px;
  padding-top: 16px;
}

.print-block {
  padding: 18px 22px 22px;
  margin-bottom: 18px;
  border: 1px solid #ebeef5;
  background: #fff;
}

.print-block h2 {
  margin: 0 0 16px;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: #303133;
}

.print-meta {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.35fr;
  gap: 12px;
  margin-bottom: 14px;
  font-size: 14px;
  color: #303133;
}

.print-table {
  width: 100%;
}

.print-table ::v-deep .el-table__footer-wrapper td {
  font-weight: 600;
  color: #303133;
}

.sign-row {
  display: flex;
  justify-content: flex-end;
  gap: 48px;
  padding-top: 14px;
  color: #303133;
}

@media (max-width: 1200px) {
  .print-meta {
    grid-template-columns: 1fr 1fr;
  }

}
</style>
